import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeScheduledReportSchema, DataResponseWithPagination } from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof BackofficeScheduledReportSchema>>
type OnSuccessFn = (data: Response) => void

const getBackofficeScheduledReportQueryKey = (id: string) => ["backofficeScheduledReports", id]

type Props = {
  id: string
  onSuccess?: OnSuccessFn
}

export const getBackofficeScheduledReportQuery = ({ id, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeScheduledReportQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/scheduledReports/${id}`)
      onSuccess?.(data)
      return data.data
    },
  })
}
